import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/admin/aircraft")({
  staticData: { title: "Aircraft" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/admin/aircraft/page.tsx"),
    "AircraftSettingsPage",
  ),
})
